import React, { useEffect, useRef, useState } from 'react';
import s from '../../styles/renewal/OnePageFooter.module.css';
import { COMPANY, PRIVACY } from './data';

const SERVICE_LINKS = [
  { id: 'about', label: 'BNPL 소개' },
  { id: 'service', label: '이용 사례' },
  { id: 'guide', label: '이용안내' },
  { id: 'cases', label: '성공사례' },
  { id: 'faq', label: '소식' },
];

const COMPANY_LINKS = [
  { id: 'about', label: 'BNPL 소개' },
  { id: 'partner', label: '제휴사모집' },
  { id: 'contact', label: '문의하기' },
];

// URL 은 기존 layout/Footer 에서 쓰던 것을 그대로 가져왔다.
const CHANNELS = [
  { label: '인스타그램', href: 'https://www.instagram.com/offer__group/' },
  { label: '네이버 블로그', href: 'https://blog.naver.com/bni_binkyung' },
  { label: '유튜브', href: 'https://youtube.com' },
];

const OnePageFooter = ({ onNavigate }) => {
  const [policyOpen, setPolicyOpen] = useState(false);
  const sheetRef = useRef(null);
  const triggerRef = useRef(null);

  // 패널이 페이지 맨 아래에 열려 화면 밖에 있을 수 있으므로 열릴 때 스크롤해 준다.
  useEffect(() => {
    if (policyOpen) sheetRef.current?.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }, [policyOpen]);

  const closePolicy = () => {
    setPolicyOpen(false);
    triggerRef.current?.focus();
  };

  return (
    <>
      <footer className={s.footer}>
        <div className={s.top}>
          <div>
            <div className={s.brand}>OFFER GROUP</div>
            <div className={s.about}>
              오퍼그룹 BNPL은 고객사가 요청한 사업용 자산·비품·원자재 등의 거래내용을 확인한 후,
              오퍼그룹이 해당 물품을 구매하여 고객사에 납품하거나 이용할 수 있도록 제공하고
              고객사는 계약에 따라 분할납부합니다.
            </div>
          </div>

          <div>
            <div className={s.colTitle}>서비스</div>
            <nav className={s.links} aria-label="서비스">
              {SERVICE_LINKS.map((item) => (
                <button
                  key={item.label}
                  type="button"
                  className={s.link}
                  onClick={() => onNavigate(item.id)}
                >
                  {item.label}
                </button>
              ))}
            </nav>
          </div>

          <div>
            <div className={s.colTitle}>회사</div>
            <nav className={s.links} aria-label="회사">
              {COMPANY_LINKS.map((item) => (
                <button
                  key={item.label}
                  type="button"
                  className={s.link}
                  onClick={() => onNavigate(item.id)}
                >
                  {item.label}
                </button>
              ))}
            </nav>
          </div>

          <div>
            <div className={s.colTitle}>고객센터</div>
            <a className={s.phone} href={`tel:${COMPANY.phone.replace(/-/g, '')}`}>
              {COMPANY.phone}
            </a>
            <div className={s.hours}>
              평일 09:00 – 18:00
              <br />
              주말·공휴일 휴무
            </div>

            <div className={s.channelTitle}>채널</div>
            <div className={s.channels}>
              {CHANNELS.map((ch) => (
                <a
                  key={ch.label}
                  className={s.channel}
                  href={ch.href}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  {ch.label}
                </a>
              ))}
            </div>
          </div>
        </div>

        <div className={s.bottom}>
          <div className={s.bizInfo}>
            주식회사 오퍼그룹 &nbsp;·&nbsp; 대표자명 : {COMPANY.ceo} &nbsp;·&nbsp; 사업자등록번호 :{' '}
            {COMPANY.bizNo}
            <br />
            본사 : {COMPANY.address}, 부천테크노밸리u1센터 1013호, 1014호, 1015호
          </div>

          <div className={s.legal}>
            <span className={s.legalItem}>이용약관</span>
            <button
              type="button"
              ref={triggerRef}
              className={s.policyBtn}
              aria-controls="offer-policy-sheet"
              aria-expanded={policyOpen}
              onClick={() => setPolicyOpen((prev) => !prev)}
            >
              {policyOpen ? '개인정보처리방침 ▲' : '개인정보처리방침'}
            </button>
            <span className={s.copyright}>© 2026 OFFER GROUP CO., LTD.</span>
          </div>
        </div>
      </footer>

      {policyOpen ? (
        <section
          id="offer-policy-sheet"
          className={s.sheet}
          ref={sheetRef}
          aria-label="개인정보처리방침"
        >
          <div className={s.sheetHandle} aria-hidden="true" />

          <div className={s.sheetHead}>
            <div>
              <h3 className={s.sheetTitle}>개인정보처리방침</h3>
              <p className={s.sheetLead}>{PRIVACY.lead}</p>
            </div>
            <button type="button" className={s.sheetClose} onClick={closePolicy}>
              닫기
            </button>
          </div>

          <div className={s.sheetBody}>
            <div className={s.policyList} aria-label="개인정보처리방침 주요 항목">
              {PRIVACY.items.map((item) => (
                <span key={item}>{item}</span>
              ))}
            </div>

            <details className={s.outsourcing} open>
              <summary>{PRIVACY.outsourcingTitle}</summary>
              <div className={s.outsourceGrid}>
                {PRIVACY.outsourcing.map((row) => (
                  <React.Fragment key={row.label}>
                    <div className={s.outLabel}>{row.label}</div>
                    <div className={s.outValue}>
                      {row.value}
                      {row.note ? <span className={s.partnerNote}>{row.note}</span> : null}
                    </div>
                  </React.Fragment>
                ))}
              </div>
            </details>

            <p className={s.version}>
              시행일: {PRIVACY.effectiveDate}　·　{PRIVACY.versionNote}
            </p>
          </div>
        </section>
      ) : null}
    </>
  );
};

export default OnePageFooter;
